(function () {
  var helperFront = {
    preventDefault: function preventDefault(event) {
      event.preventDefault();
    }
  };
  if ($('.x-prevent-default').length > 0) {
    $('body').on('click', '.x-prevent-default', helperFront.preventDefault);
  }
})();

$(document).ready(function () {
  $('.x-checkbox-click').click(function () {
    window.location.href = $(this).data('clickLink');
  });

  $('.x-tooltip-question').on('click', function () {
    $(this).toggleClass('active').siblings('.tooltip').toggleClass('hide');
  });

  $('.x-tooltip-link').on('click', function (e) {
    e.preventDefault();
    $(this).siblings('.tooltip').toggleClass('hide');
  });
});

var scrollable = document.querySelector('.x-scrollable');
if (document.body.contains(scrollable)) {
  var perfectScroll = new PerfectScrollbar(scrollable, {
    wheelSpeed: 1,
  });
}

function accordionWidget() {
  var accordionItem = document.querySelectorAll('.x-accordion-item');
  var accordionTrigger = document.querySelectorAll('.x-accordion-trigger');
  var accordionActiveClass = 'active';
  accordionTrigger.forEach(function(element){
    element.addEventListener('click', function() {
      accordionItem.forEach(function(item){
        if(item != element.parentNode) {
          item.classList.remove(accordionActiveClass);
        }
      });
      element.parentNode.classList.toggle(accordionActiveClass);
    });
  });
  accordionMore();
}

function accordionMore() {
  var accordionMoreTrigger = document.querySelector('.x-accordion-more-trigger');
  var accordionMoreContent = document.querySelector('.x-accordion-more');
  if(document.contains(accordionMoreContent)) {
    accordionMoreTrigger.addEventListener('click', function(e) {
      accordionMoreContent.classList.toggle('hide');
      this.classList.toggle('active');
      this.textContent = this.textContent === 'Pokaż więcej' ? 'Ukryj' : 'Pokaż więcej';
      e.preventDefault();
    });
  }
}

function displayTelNumber() {
  var telNr = document.querySelectorAll('.x-tel-number');
  telNr.forEach(function(elem){
    var telData = elem.dataset.tel;
    elem.nextElementSibling.addEventListener('click', function(e) {
      elem.innerHTML = telData;
      this.remove();
      e.preventDefault();
    });
  });
}

if(document.getElementById('message_form')) {
  document.getElementById('message_form').addEventListener('click', function (e) {
    var messageForm = document.getElementById('new_form_data');
    var messageFormTop = messageForm.getBoundingClientRect().top + window.scrollY;
    var pageOverlayer = document.querySelector('.x-page-overlayer');
    e.preventDefault();
    e.stopPropagation();

    window.scroll({
      top: messageFormTop,
      behavior: 'smooth'
    });
    pageOverlayer.classList.remove('is-visible');
  });
}

accordionWidget();
displayTelNumber();

